<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="渠道ID">
              <el-input v-model="queryParams.id" placeholder="请输入渠道ID" @change="search" @clear="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="用户名">
              <el-input v-model="queryParams.username" placeholder="请输入用户名" @change="search" @clear="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="昵称">
              <el-input v-model="queryParams.nickname" placeholder="请输入昵称" @change="search" @clear="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="投放类型">
              <el-select v-model="queryParams.launch_type" placeholder="请选择平台类型" @change="search" @clear="search" clearable class="w100">
                <el-option label="内部自投" value="0"></el-option>
                <el-option label="渠道分销" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小程序名称">
              <el-select v-model="queryParams.app_id" placeholder="请选择小程序名称" @change="search" @clear="search" clearable class="w100">
                <el-option v-for="dict in appidList" :key="dict.dictValue" :label="dict.name"
                           :value="dict.uuid"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="状态">
              <el-select v-model="queryParams.status" placeholder="请选择状态" @change="search" @clear="search" clearable class="w100">
                <el-option label="正常" value="1"></el-option>
                <el-option label="隐藏" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button size="medium" @click="addNoNe">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="ID">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="用户名">
          <template slot-scope="scope">{{ scope.row.username }}</template>
        </el-table-column>
        <el-table-column prop="name" label="昵称">
          <template slot-scope="scope">{{ scope.row.nickname }}</template>
        </el-table-column>
        
        <el-table-column prop="name" label="投放类型">
          <template slot-scope="scope">
            <span v-if="scope.row.launch_type == 0">内部自投</span>
            <span v-if="scope.row.launch_type == 1">渠道分销</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="公司全称" width="250">
          <template slot-scope="scope">{{ scope.row.company_name }}</template>
        </el-table-column>
        <el-table-column prop="name" label="公司简称">
          <template slot-scope="scope">{{ scope.row.company_abbr }}</template>
        </el-table-column>
        <el-table-column prop="name" width="200" label="微信小程序">
          <template slot-scope="scope">{{ scope.row.wx_appname }}</template>
        </el-table-column>
        <el-table-column prop="name" label="角色组">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.group_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>隐藏</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="最后登录" width="190">
          <template slot-scope="scope">{{ scope.row.logintime }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
            <!-- <el-button type="text" size="medium" @click="jump(scope.row.id)">登录</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize" @pagination="getList"/>
      <business v-if="dialogVisible" :dialogVisible="dialogVisible" @busNone="busNone"></business>
      <AddVip v-if="vipFlag" :vipFlag="vipFlag" @NonevipFlag="NonevipFlag" @AddVipok="AddVipok" :editID="editID">
      </AddVip>
    </el-card>
  </div>
</template>

<script>
import {VIPmanagementAPI} from '@/api/account/VIPmanagement';
import business from "./component/business.vue"
import AddVip from "./component/AddVip.vue"
import {processErrors} from "@/utils/errorHandler";
import {useLoginApi} from '@/api/login/index';

export default {
  components: {
    business,
    AddVip
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();  // 可选历史天、可选当前天、不可选未来天
        },
      },
      form: {
        name: ""
      },
      SearchFlag: false,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        id: "",
        username: "",
        launch_type: "",
        status: "",
        app_id: ""
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
        type: "4"
      },

      tableData: [],
      multipleSelection: [],
      dialogVisible: false,

      editID: "",
      // 总条数
      total: 0,
      vipFlag: false,
      loading: false
    };
  },
  created() {
    this.getList()
    this.getapplication()
    this.getUserinfo()
  },
  methods: {
    getUserinfo() {
      const api = useLoginApi();
      api.getUserinfo().then((res) => {
        Session.set("roleId", res.data.roleId)
      })
    },
    jump(id){
      
      let api = useLoginApi()
      api.getToken({id:id}).then(res => {
        if (res.code == 0) {
          let token = res.data.token;
          const urlParams = new URLSearchParams();
          urlParams.append('token', token)
          // 获取基础 URL
          const baseExportUrl = new URL(window.location.href).origin;
          // 拼接 URL 参数
          // window.location.href = baseExportUrl + '?' + urlParams.toString()
          let url = baseExportUrl + '?' + urlParams.toString()
          window.open(url);
          api.getUserinfo().then((res) => {

          })
        }else{
          processErrors(res);
        }
      })
    },
    getList() {
      this.loading = true
      let api = VIPmanagementAPI()
      api.VIPmanagementList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },
    getapplication() {
      let api = VIPmanagementAPI()
      let params = {
        status: 1,
      }
      api.applicationList(params).then(res => {
        if (res.code == 0) {
          this.appidList = res.data.data
        } else {
          processErrors(res);
        }
      })
    },
    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true
      } else {
        this.SearchFlag = false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    search() {
      this.getList()
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        id: "",
        username: "",
        launch_type: "",
        status: "",
        app_id: ""
      }
      this.getList()
    },
    AddbusinessFlag() {
      this.dialogVisible = true
    },
    busNone() {
      this.dialogVisible = false
    },
    addList() {
      this.editID = ""
      this.vipFlag = true
    },
    NonevipFlag() {
      this.vipFlag = false
    },
    AddVipok() {
      this.getList()
      this.vipFlag = false
    },
    addEdit(row) {
      this.editID = row.id

      this.vipFlag = true
    }
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>